export default __webpack_public_path__ + "static/media/Cera_Scaglie_Incenso_120x120_small.854233d8.jpg";